import { render, staticRenderFns } from "./OptionalObjectField.vue?vue&type=template&id=1269dc3a&scoped=true&"
import script from "./OptionalObjectField.vue?vue&type=script&lang=js&"
export * from "./OptionalObjectField.vue?vue&type=script&lang=js&"
import style0 from "./OptionalObjectField.vue?vue&type=style&index=0&id=1269dc3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1269dc3a",
  null
  
)

export default component.exports